/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ActivitiesDto,
} from '../models/index';
import {
    ActivitiesDtoFromJSON,
    ActivitiesDtoToJSON,
} from '../models/index';

export interface GetTeamActivitiesRequest {
    teamId: number;
    page?: number;
    pageSize?: number;
    deploymentId?: number;
}

/**
 * 
 */
export class ActivitiesApi extends runtime.BaseAPI {

    /**
     * Gets the team activity log.
     * 
     */
    async getTeamActivitiesRaw(requestParameters: GetTeamActivitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActivitiesDto>> {
        if (requestParameters.teamId === null || requestParameters.teamId === undefined) {
            throw new runtime.RequiredError('teamId','Required parameter requestParameters.teamId was null or undefined when calling getTeamActivities.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.deploymentId !== undefined) {
            queryParameters['deploymentId'] = requestParameters.deploymentId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = await this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/teams/{teamId}/activities`.replace(`{${"teamId"}}`, encodeURIComponent(String(requestParameters.teamId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActivitiesDtoFromJSON(jsonValue));
    }

    /**
     * Gets the team activity log.
     * 
     */
    async getTeamActivities(teamId: number, page?: number, pageSize?: number, deploymentId?: number, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActivitiesDto> {
        const response = await this.getTeamActivitiesRaw({ teamId: teamId, page: page, pageSize: pageSize, deploymentId: deploymentId }, initOverrides);
        return await response.value();
    }

}
